import { useEffect, useState } from 'react';

const MULTIPLIER_OFFSET = 1000;
const DIVISION_OFFSET = 1000;
const SECOND =60;
const MINUTE=60;
const HOUR=24

const getReturnValues = (countDown) => {
  // calculate time left
  const days = Math.floor(countDown / (MULTIPLIER_OFFSET * MINUTE * SECOND * HOUR));
  const hours = Math.floor(
    (countDown % (MULTIPLIER_OFFSET * MINUTE * SECOND * HOUR)) / (DIVISION_OFFSET * MINUTE * SECOND)
  );
  const minutes = Math.floor((countDown % (MULTIPLIER_OFFSET * MINUTE * SECOND)) / (DIVISION_OFFSET * MINUTE));
  const seconds = Math.floor((countDown % (MULTIPLIER_OFFSET * MINUTE)) / DIVISION_OFFSET);

  return [days, hours, minutes, seconds];
};

const useCountdown = (targetDate) => {
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(countDownDate - new Date().getTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
};

export { useCountdown };
